import t from '@jetshop/intl';
import React, { useMemo, useState, useEffect } from 'react';
import { styled } from 'linaria/react';
import CategoryHeaderLoadingState from './CategoryHeaderLoadingState';
import Filters from './Filters';
import ProductGridWindow from './ProductGridWindow';
import routeQuery from '../RouteQuery.gql';
import useInfinitePagination from '@jetshop/core/hooks/useInfinitePagination';
import { useLocation } from 'react-router';
import { TrendLink } from '../ui/Button';
import qs from 'qs';
import { theme } from '../Theme';
import { ReactComponent as List } from '../../svg/List.svg';
import { ReactComponent as ListActive } from '../../svg/List-active.svg';
import { ReactComponent as Grid } from '../../svg/Grid.svg';
import { ReactComponent as GridActive } from '../../svg/Grid-active.svg';
import {
  allContentComponents,
  seoComponents
} from '../ContentEditor/ContentComponents';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import FilterDrawer from './Filters/FilterDrawer';
import { SortOrders } from './Filters/SortOrders';
import { Breadcrumbs } from '../ui/Breadcrumbs';
import loadable from '@loadable/component';
import LoadingPage from '../LoadingPage';
import CategoryLink from '@jetshop/ui/CategoryLink';

export const LoadableBrandListPage = loadable(() => import('./BrandListPage'), {
  fallback: <LoadingPage />
});

export const LoadableJournalList = loadable(
  () => import('./Journal/JournalList'),
  {
    fallback: <LoadingPage />
  }
);

export const LoadableContentRenderer = loadable(
  () => import('@jetshop/ui/ContentRenderer'),
  {
    fallback: <LoadingPage />,
    resolveComponent: ContentRenderer => ContentRenderer.ContentRenderer
  }
);

const ProductNumber = styled('p')`
  font-family: ${theme.fonts.primaryFontFamily};
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #282828;
  margin-top: 0;
  margin-bottom: 10px;

  &.small {
    font-family: ${theme.fonts.primaryFontFamily};
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 6px;
    color: #333333;
  }
`;

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-bottom: 8px;
`;

//new
const CategoryWrapper = styled('div')`
  display: flex;
  width: 100%;
  margin-bottom: 40px;
  margin-top: 30px;

  .product-grid {
    margin: 0 -1em 1em;
  }

  ${theme.below.lg} {
    overflow: hidden;
    .list {
      margin: 0;
    }
    .grid {
      margin: 0 -5px;
    }
  }
`;

const FiltersWrapper = styled('aside')`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  max-width: 18%;
  height: 100%;
  width: 100%;
  position: sticky;
  top: 120px;
`;

const InnerFilterWrapper = styled('div')`
  ul {
    margin: 0;
    padding: 0;
    margin-bottom: 20px;

    button {
      background: none;
    }
  }

  input {
    margin: 0 5px 0 0;
  }

  li,
  p {
    font-family: ${theme.fonts.primaryFontFamily};
    font-weight: 400;
    font-size: 14px;
    line-height: 25px;
    color: #282828;
    list-style-type: none;
  }
`;

const CatgoryInnerWrapper = styled('div')`
  max-width: 80%;
  width: 100%;

  ${theme.below.lg} {
    max-width: 100%;
  }
`;

const CategoryGridWrapper = styled('div')`
  margin: 0 30px;

  ${theme.below.lg} {
    margin: 0;
    .product-link {
      margin: 0 5px 5px !important;
      .product-card-detail {
        padding: 12px 10px;
      }
    }
  }
`;

const TopCategoryWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  margin: 0 20px;

  ${theme.below.lg} {
    flex-direction: column;
  }
`;

export const CategoryHeaderWrapper = styled('div')`
  h1 {
    font-family: ${theme.fonts.primaryFontFamily};
    font-weight: 700;
    font-size: 43px;
    line-height: 52px;
    margin: 0;
    color: #282828;
  }

  ${theme.below.lg} {
    h1 {
      font-size: 28px;
      line-height: 34px;
    }
  }
`;

const BreadcrumbsWrapper = styled('div')`
  margin: 10px 20px;
  ul {
    margin: 0;
    padding: 0;
  }

  ${theme.below.lg} {
    margin: 20px 20px 10px;
  }
`;

const SortWrapper = styled('div')`
  display: flex;
  align-items: center;

  .grid-display {
    display: flex;
    margin-right: 20px;
    ${theme.below.lg} {
      margin: 0;
    }
    div {
      margin-left: 10px;
    }
  }

  .view-toggle {
    cursor: pointer;
  }

  .sort-orders {
    width: 100%;
    button {
      outline: none;
      border: none;
      padding: 0;
      margin-right: 10px;
      font-weight: 700;
      font-size: 12px;
      line-height: 17px;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }
    button:focus {
      border: none;
    }
    [data-flight-dropdown] {
      margin: 0;
    }

    ul {
      width: 100%;
      min-width: 200px;
      left: unset;
      right: 0;
      top: calc(100% - -4px);
      background: #fff;
      border: none;
    }

    li {
      background: none;
      border: none;
    }

    span {
      margin-top: 6px;
    }
  }

  ${theme.below.lg} {
    justify-content: space-between;
    margin-bottom: 10px;
  }
`;

const SeoWrapper = styled('div')`
  background: ${theme.colors.lightgrey};
  padding: 50px 0;

  > div {
    width: 100%;
    max-width: 50rem;
    margin: auto;
  }

  h2 {
    font-family: ${theme.fonts.primaryFontFamily};
    font-weight: 500;
    font-size: 28px;
    line-height: 25px;
    color: ${theme.colors.darkgrey};
  }

  p,
  li,
  a {
    font-family: ${theme.fonts.primaryFontFamily};
    font-weight: 400;
    font-size: 14px !important;
    line-height: 21px !important;
    color: ${theme.colors.darkgrey};
  }

  ${theme.below.lg} {
    padding: 40px 0;
    h2 {
      font-size: 24px;
      line-height: 24px;
      margin-bottom: 10px;
    }
  }
`;

const GraphWrapper = styled('div')`
  width: calc(100% / 3);
  margin: 20px auto;
`;

const GraphBar = styled('div')`
  height: 3px;
  background: #33333333;
  position: relative;
  width: 100%;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    background: ${theme.colors.black};
    left: 0;
    height: 100%;
    width: ${props => Math.round(props.fill)}%;
  }
`;

const ButtonWrapper = styled('div')`
  width: 100%;
  max-width: 202px;
  margin: 0 auto 20px auto;

  a {
    background-color: ${theme.colors.black} !important;
    color: #fff !important;
    font-weight: 400 !important;
    font-family: ${theme.fonts.primaryFontFamily};
    font-size: 14px !important;
    line-height: 20px !important;
    letter-spacing: 0.04em !important;
    text-transform: uppercase !important;
    border-radius: 0 !important;
    text-align: center;
    height: 43px !important;
  }
`;

const CategoriesLinksWrapper = styled('div')`
  display: flex;
  margin: 0 20px;
  p {
    font-weight: 500;
  }

  ${theme.below.lg} {
    margin-bottom: 20px;
    margin: 0;
  }
`;

const CategoryNavigation = styled('div')`
  display: flex;
  flex-wrap: wrap;

  ${theme.below.lg} {
    flex-wrap: nowrap;
    /* padding: 0 20px; */
    /* margin: 17px 0; */
    overflow-x: scroll;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
`;

const CategoryNavigationItem = styled(CategoryLink)`
  padding: 13px 30px;
  background: ${theme.colors.grey};
  color: ${theme.colors.darkgrey};
  margin-right: 10px;
  margin-top: 10px;
  font-weight: 700;
  font-size: 12px;
  line-height: 17px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  border-radius: ${theme.button.desktop.borderRadius};

  ${theme.below.lg} {
    width: 100%;
    min-width: fit-content;
    text-align: center;
    :first-child {
      margin-left: 20px;
    }
  }
`;

const StatusBar = ({ percentage }) => {
  return (
    <GraphWrapper>
      <GraphBar fill={percentage} />
    </GraphWrapper>
  );
};

const CategoriesLinks = ({ category }) => {
  return (
    <>
      <CategoryNavigation>
        {category?.subcategories?.map(subcategory => {
          return (
            <CategoryNavigationItem key={subcategory.id} category={subcategory}>
              {subcategory?.name}
            </CategoryNavigationItem>
          );
        })}
      </CategoryNavigation>
    </>
  );
};

const WindowedCategory = ({ category, result }) => {
  const { previous, next, products } = useInfinitePagination({
    result,
    query: routeQuery
  });
  const isInformationCategory =
    category?.id === 195 ||
    category?.id === 193 ||
    category?.id === 197 ||
    category?.id === 199 ||
    category?.id === 231;
  const [listGrid, setListGrid] = useState(false);
  const location = useLocation();
  const params = qs.parse(location.search, { ignoreQueryPrefix: true });
  const routePath = category?.isDynamic ? null : result?.data?.route?.path;
  const categoryPath = useMemo(() => routePath && { path: routePath }, [
    routePath
  ]);
  const breadcrumbProps = {
    breadcrumbs: result?.data?.route?.breadcrumbs,
    parents: result?.data?.route?.parents
  };
  const nowShowing =
    result?.variables?.offset + (category?.products?.result?.length ?? 0);

  const totalResults = category?.products?.totalResults;
  const hasProducts = category?.products?.totalResults;
  const hasSeo = category?.data?.items?.find(item => item.type === 'SeoRow');
  const items = category?.data?.items;
  const hasSubcategories = category?.subcategories?.length > 0;
  if (!category) {
    return (
      <CategoryWrapper>
        <CategoryHeaderLoadingState />
      </CategoryWrapper>
    );
  }

  // if (category?.id === 177) {
  //   return (
  //     <LoadableBrandListPage
  //       breadcrumbProps={breadcrumbProps}
  //       category={category}
  //     />
  //   );
  // }

  if (category?.id === parseInt(process?.env?.REACT_APP_ARTICLES_ID)) {
    return (
      <LoadableJournalList
        category={category}
        breadcrumbProps={breadcrumbProps}
      />
    );
  }

  if (isInformationCategory) {
    return (
      <>
        <BreadcrumbsWrapper>
          <Breadcrumbs {...breadcrumbProps} />
        </BreadcrumbsWrapper>
        {items && (
          <div>
            <LoadableContentRenderer
              items={items}
              components={allContentComponents}
            />
          </div>
        )}
        <div>
          {hasSeo && (
            <SeoWrapper>
              {items && (
                <LoadableContentRenderer
                  items={items}
                  components={seoComponents}
                />
              )}
            </SeoWrapper>
          )}
        </div>
      </>
    );
  }

  return (
    <>
      {items && (
        <div>
          <LoadableContentRenderer
            items={items}
            components={allContentComponents}
          />
        </div>
      )}
      <div>
        <BreadcrumbsWrapper>
          <Breadcrumbs {...breadcrumbProps} />
        </BreadcrumbsWrapper>
        {hasSubcategories && (
          <CategoriesLinksWrapper>
            <CategoriesLinks category={category} />
          </CategoriesLinksWrapper>
        )}
        <CategoryWrapper>
          <Above breakpoint="md">
            {matches =>
              matches && (
                <FiltersWrapper>
                  <ProductNumber>
                    {t(' Showing {totalProducts} Products', {
                      totalProducts: category.products?.totalResults
                    })}
                  </ProductNumber>
                  <InnerFilterWrapper className="filters-wrapper">
                    <FilterDrawer
                      close={null}
                      filters={category?.products?.filters || []}
                      sortOrders={category?.products?.sortOrders || []}
                    />
                  </InnerFilterWrapper>
                </FiltersWrapper>
              )
            }
          </Above>
          <CatgoryInnerWrapper>
            <TopCategoryWrapper>
              <CategoryHeaderWrapper>
                <h1>{category.mainHeader}</h1>
              </CategoryHeaderWrapper>

              <SortWrapper>
                <Below breakpoint="lg">
                  {matches =>
                    matches && (
                      <Filters
                        filters={category.products?.filters || []}
                        sortOrders={category.products?.sortOrders || []}
                        result={result}
                        totalProducts={category?.products?.totalResults}
                      />
                    )
                  }
                </Below>
                <div className="grid-display">
                  <div
                    onClick={() => setListGrid(true)}
                    className="view-toggle"
                  >
                    {listGrid ? <ListActive /> : <List />}
                  </div>
                  <div
                    onClick={() => setListGrid(false)}
                    className="view-toggle"
                  >
                    {listGrid ? <Grid /> : <GridActive />}
                  </div>
                </div>
                <Above breakpoint="lg">
                  {matches =>
                    matches && (
                      <div className="sort-orders">
                        <SortOrders
                          sortOrders={category?.products?.sortOrders || []}
                        />
                      </div>
                    )
                  }
                </Above>
              </SortWrapper>
            </TopCategoryWrapper>
            {hasProducts && (
              <CategoryGridWrapper>
                {previous.hasProducts && (
                  <ButtonWrapper>
                    <TrendLink
                      className="secondary"
                      onClick={e => {
                        e.preventDefault();
                        previous.fetchProducts();
                      }}
                      to={{
                        ...location,
                        search: qs.stringify({
                          ...params,
                          page: previous.page
                        })
                      }}
                    >
                      {t('Show more products')}
                    </TrendLink>
                  </ButtonWrapper>
                )}
                <ProductGridWindow
                  id="category"
                  prevOffset={previous.offset}
                  products={products}
                  listName={category.name}
                  categoryPath={categoryPath}
                  category={result?.data?.route?.breadcrumbs?.join('/') || ''}
                  loading={result.loading}
                  imageSizes={[1 / 2, 1 / 2, 1 / 3, 1 / 4]}
                  listGrid={listGrid}
                />
                {next.hasProducts && (
                  <>
                    <ProductNumber className="small">
                      Visar {nowShowing} av {totalResults} st artiklar
                    </ProductNumber>
                    <ButtonWrapper>
                      <TrendLink
                        className="secondary"
                        onClick={e => {
                          e.preventDefault();
                          next.fetchProducts();
                        }}
                        to={{
                          ...location,
                          search: qs.stringify({
                            ...params,
                            page: next.page
                          })
                        }}
                      >
                        {t('Show more products')}
                      </TrendLink>
                    </ButtonWrapper>
                    <StatusBar percentage={(nowShowing / totalResults) * 100} />
                  </>
                )}
              </CategoryGridWrapper>
            )}
          </CatgoryInnerWrapper>
        </CategoryWrapper>

        {hasSeo && (
          <SeoWrapper>
            {items && (
              <LoadableContentRenderer
                items={items}
                components={seoComponents}
              />
            )}
          </SeoWrapper>
        )}
      </div>
    </>
  );
};

export default WindowedCategory;
